import React, { createContext, useContext, useState } from "react";

interface completion {
  points: string[];
  setPoints: React.Dispatch<React.SetStateAction<string[]>>;
}

const CompletionContext = createContext<completion | null>(null);

export const CompletionProvider = ({ children }: { children: React.ReactNode }) => {
  const [points, setPoints] = useState<string[]>([]);

  return (
    <CompletionContext.Provider value={{ points, setPoints }}>
      {children}
    </CompletionContext.Provider>
  );
};

export const useCompletionContext = (): completion => {
  const context = useContext(CompletionContext);
  if (!context) {
    throw new Error("completion context must be used within a completion provider");
  }
  return context;
};
